/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { organizationsControllerCheckEntitlement } from "./organizationsControllerCheckEntitlement";
import { organizationsControllerCreate } from "./organizationsControllerCreate";
import { organizationsControllerFindAll } from "./organizationsControllerFindAll";
import { organizationsControllerFindOne } from "./organizationsControllerFindOne";
import { organizationsControllerFindOwners } from "./organizationsControllerFindOwners";
import { organizationsControllerGetProjectQuota } from "./organizationsControllerGetProjectQuota";
import { organizationsControllerRemove } from "./organizationsControllerRemove";
import { organizationsControllerUpdate } from "./organizationsControllerUpdate";

export function organizationsService() {
  return { organizationsControllerCreate, organizationsControllerFindAll, organizationsControllerFindOwners, organizationsControllerFindOne, organizationsControllerUpdate, organizationsControllerRemove, organizationsControllerCheckEntitlement, organizationsControllerGetProjectQuota }
}